export default {
    title: 'การบ้านของฉัน',
    hero: {
        bgAlt: 'ภาพพื้นหลังสวนสนุก',
        panelAlt: 'แผงชื่อการบ้านของฉัน',
        title: 'การบ้านของฉัน',
        description: 'มาดูการบ้านที่คุณครูมอบให้<br/>แล้วค่อยๆ ทำทีละอย่างกันนะ',
    },
    aria: {
        boardLabel: 'บอร์ดการบ้าน',
        tabsLabel: 'แท็บสถานะการบ้าน',
        progress: 'ความคืบหน้าการบ้าน {percent}%',
        actionButton: '{title} {label}',
    },
    tabs: {
        active: 'การบ้านที่กำลังทำ',
        ended: 'การบ้านที่ปิดรับแล้ว',
    },
    meta: {
        activityCount: 'จำนวนกิจกรรม',
        createdAt: 'วันที่สร้าง',
        endedAt: 'วันที่สิ้นสุด',
    },
    status: {
        before: 'ยังไม่เริ่ม',
        inprogress: 'กำลังทำ',
        complete: 'เสร็จสิ้น',
        endedComplete: 'เสร็จสิ้น',
        endedIncomplete: 'ยังไม่เสร็จ',
    },
    actions: {
        view: 'ดูการบ้าน',
        studyComplete: 'เรียนเสร็จ',
        viewResult: 'ดูผลลัพธ์',
    },
    stamp: {
        alt: 'ตราเรียนเสร็จ',
    },
    empty: {
        active: 'ยังไม่มีการบ้านที่กำลังทำ',
        ended: 'ยังไม่มีการบ้านที่ปิดรับ',
    },
    activity: {
        name: 'กิจกรรม {index}',
    },
    modal: {
        closeAria: 'ปิดหน้าต่าง',
        close: 'ปิด',
        start: 'เริ่ม',
    },
    flash: {
        title: {
            info: 'แจ้งเตือน',
            warning: 'คำเตือน',
            error: 'ข้อผิดพลาด',
        },
        confirm: 'ยืนยัน',
    },
};
